let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kDRN4")).then(() => parcelRequire('cSNAI'));